import React, { useRef, useEffect, useState } from 'react';
import styles from './image-upload.module.scss';
import {
  ImagePrev,
  Trash,
  Pause,
  UploadClose,
  ImageChange,
  ErrorIcon,
} from '../../assets/svgs';
import ProgressBar from '@ramonak/react-progress-bar';
import ToolTip from 'components/Tooltip';

const ImageUpload = (props) => {
  const [imageName, setImageName] = useState('image.jpeg');

  const uploadInputRef = useRef(null);
  const uploadingRef = useRef(null);

  useEffect(() => {
    if (props.value !== '') {
      props.setState(3);
    }
  }, []);

  useEffect(() => {
    if (props.state !== 2) {
      return;
    }
    let progress = setInterval(() => {
      if (props.prog === 80) {
        props.setProg(80);
        clearInterval(progress);
      }
      props.setProg(props.prog + 20);
    }, 1000);
    return () => {
      clearInterval(progress);
    };
  }, [props.state, props.prog]);

  const handleButtonClick = (e) => {
    props.setProg(0);
    e.stopPropagation();
    uploadInputRef.current.click();
  };

  const hanldeOnUpload = (e) => {
    e.preventDefault();
    const image = uploadInputRef.current.files[0];
    if (!image) return;
    setImageName(image?.name);
    const data = new FormData();
    data.append('file', image);
    props.uploadToDrake(data);
  };

  const getCroppedImg = (image) => {
    const canvas = document.createElement('canvas');
    const crop = {
      x: 0,
      y: 0,
      width: 215,
      height: 215,
    };
    const sWidth = image.naturalWidth;
    const sHeight = image.naturalHeight;
    canvas.width = crop.width;
    canvas.height = crop.height;
    const ctx = canvas.getContext('2d');

    ctx.drawImage(
      image,
      crop.x,
      crop.y,
      sWidth,
      sHeight,
      crop.x,
      crop.y,
      crop.width,
      crop.height,
    );
    const base64Image = canvas.toDataURL('image/jpeg');
    return base64Image;
  };

  useEffect(() => {
    const uploading = uploadingRef.current;
    const imageURL = getCroppedImg(uploading);
    uploading.src = imageURL;
  }, [props.state]);

  const truncate = (val) => {
    return val.length > 30 ? `${val.substring(0, 30)}...` : val;
  };

  return (
    <>
      <div
        style={{ display: 'none', visibility: 'hidden' }}
        data-testid="file-input"
      >
        {/* File Input */}

        <input
          ref={uploadInputRef}
          type="file"
          onChange={hanldeOnUpload}
          accept={
            props.accept ? props.accept : 'image/png, image/jpeg, image/jpg'
          }
          onClick={(e) => (e.target.value = null)}
          data-testid="input"
        />
      </div>
      <div className={styles.imageUpload}>
        <div className={styles.imageUploadLabel}>
          <label htmlFor={props.name}>{props.label}</label>
          {props.tooltipId && (
            <ToolTip id={props.tooltipId} content={props.tooltipMsg} />
          )}
        </div>

        {/* No image state */}

        <div
          className={
            props.type === 'box'
              ? styles.imageUploadBox
              : props.type === 'file'
              ? styles.imageUploadFile
              : styles.imageUploadButton
          }
          onClick={handleButtonClick}
          style={
            props.state !== 1 ? { display: 'none', visibility: 'hidden' } : {}
          }
          data-testid="no-image"
        >
          {props.type !== 'file' && <ImagePrev />}

          <p>{props.text}</p>
        </div>
        {props.error && (
          <p className={styles.imageUploadError}>
            <ErrorIcon />
            {props.error}
          </p>
        )}
        {/* Uploading State */}

        <div
          className={styles.imageUploadUploading}
          style={
            props.state !== 2 ? { display: 'none', visibility: 'hidden' } : {}
          }
          data-testid="uploading-image"
        >
          <img
            ref={uploadingRef}
            className={styles.imageUploadSuccessPic}
            src=""
            alt=""
          />
          <div style={{ flex: '1' }}>
            <div className={styles.imageUploadUploadingBody}>
              <p>Uploading</p>
              <div className={styles.imageUploadUploadingBodyIcons}>
                <div>
                  <Pause />
                </div>
                <div className={styles.imageUploadUploadingBodyIconsClose}>
                  <UploadClose />
                </div>
              </div>
            </div>

            <ProgressBar
              completed={props.prog || 0}
              bgColor="#1E1147"
              baseBgColor="rgba(30, 17, 71, 0.08)"
              height="3px"
              width="100%"
              borderRadius="4px"
              isLabelVisible={false}
            />
          </div>
        </div>

        {/* Image uploaded state */}
        {props.type !== 'box' ? (
          <div
            className={styles.imageUploadSuccess}
            style={
              props.state !== 3 ? { display: 'none', visibility: 'hidden' } : {}
            }
            data-testid="uploaded-image"
          >
            <div className={styles.imageUploadSuccessLeft}>
              {props.allowFile ? (
                <ImagePrev />
              ) : (
                <img
                  className={styles.imageUploadSuccessPic}
                  src={props.value}
                  alt=""
                />
              )}
              <p>{truncate(imageName)}</p>
            </div>

            <div
              className={styles.imageUploadSuccessRight}
              onClick={() => props.setState(1)}
            >
              <Trash />
              <p>Remove</p>
            </div>
          </div>
        ) : (
          <div
            className={styles.imageUploadBoxSuccess}
            style={
              props.state !== 3 ? { display: 'none', visibility: 'hidden' } : {}
            }
          >
            <img
              className={styles.imageUploadBoxSuccessPic}
              src={props.value}
              alt=""
            />
            <div className={styles.imageUploadBoxSuccessRight}>
              <h5>{truncate(imageName)}</h5>
              <div className={styles.imageUploadBoxSuccessChange}>
                <ImageChange />
                <p onClick={(() => () => props.setState(1), handleButtonClick)}>
                  Change Logo
                </p>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default ImageUpload;
